import store from "../store";

export default function loginMiddleware(to, from, next) {
    if (store.getters['auth/loggedIn']) {
        try {
            return next('/');
        } catch (e) {
            console.warn(e)
        }
    }
    return next();
}